
export default function About() {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          <div className="space-y-6">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900">
              About ManAgro
            </h2>
            <p className="text-lg text-gray-600 leading-relaxed">
              ManAgro doo Backa Topola is a technology company dedicated to developing innovative software solutions that enhance digital security and user experience. Based in Serbia, we specialize in creating applications that protect and optimize your digital life.
            </p>
            <p className="text-lg text-gray-600 leading-relaxed">
              Our flagship VPN application represents our commitment to privacy and security. We believe that everyone deserves access to a free and open internet without compromising their personal data or online safety.
            </p>
            <p className="text-lg text-gray-600 leading-relaxed">
              With cutting-edge encryption technology and a user-first approach, ManAgro continues to innovate in the cybersecurity space, providing reliable solutions for individuals and businesses worldwide.
            </p>
            
            <div className="grid grid-cols-2 gap-6 pt-6">
              <div className="space-y-2">
                <div className="w-12 h-12 bg-blue-50 rounded-lg flex items-center justify-center">
                  <i className="ri-map-pin-line text-blue-600 text-xl"></i>
                </div>
                <h4 className="font-bold text-gray-900">Location</h4>
                <p className="text-gray-600">Backa Topola, Serbia</p>
              </div>
              <div className="space-y-2">
                <div className="w-12 h-12 bg-purple-50 rounded-lg flex items-center justify-center">
                  <i className="ri-focus-line text-purple-600 text-xl"></i>
                </div>
                <h4 className="font-bold text-gray-900">Focus</h4>
                <p className="text-gray-600">VPN Security Solutions</p>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img 
                src="https://public.readdy.ai/ai/img_res/17f282528b470ee5b7ae49192eb14f98.jpg"
                alt="ManAgro Technology"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 w-48 h-48 bg-gradient-to-br from-blue-600 to-purple-600 rounded-2xl -z-10"></div>
            <div className="absolute -top-6 -left-6 w-48 h-48 bg-gradient-to-br from-purple-400 to-blue-400 rounded-2xl -z-10 opacity-50"></div>
          </div>
        </div>
      </div>
    </section>
  );
}
